export function sessionPath(): string {
  return '/session';
}

export function inboxPath(): string {
  return '/app/inbox';
}

export function pulsePath(): string {
  return '/app/pulse';
}

export function draftsPath(): string {
  return '/app/drafts';
}

export function searchPath(): string {
  return '/app/search';
}

export function myIssuesPath(): string {
  return '/app/my-issues';
}

export function issuesPath(): string {
  return '/app/issues';
}

export function issuePath(id: string): string {
  return `/app/issues/${id}`;
}

export function issueIdentifierPath(identifier: string): string {
  return `/app/${identifier}`;
}

export function issueCommentsPath(issueId: string): string {
  return `/app/issues/${issueId}/comments`;
}

export function issueCommentPath(issueId: string, id: string): string {
  return `/app/issues/${issueId}/comments/${id}`;
}

export function issueStatusPath(issueId: string): string {
  return `/app/issues/${issueId}/status`;
}

export function issueAssigneePath(issueId: string): string {
  return `/app/issues/${issueId}/assignee`;
}

export function issuePriorityPath(issueId: string): string {
  return `/app/issues/${issueId}/priority`;
}

export function issueSubIssuesPath(issueId: string): string {
  return `/app/issues/${issueId}/sub_issues`;
}

export function issueSubIssuePath(issueId: string, id: string): string {
  return `/app/issues/${issueId}/sub_issues/${id}`;
}

export function issueLabelsPath(issueId: string): string {
  return `/app/issues/${issueId}/labels`;
}

export function issueLabelPath(issueId: string, labelId: string): string {
  return `/app/issues/${issueId}/labels/${labelId}`;
}

export function labelsPath(): string {
  return '/app/labels';
}

export function settingsLabelsPath(): string {
  return '/app/settings/labels';
}

export function labelPath(id: string): string {
  return `/app/labels/${id}`;
}

export function favoritesPath(): string {
  return '/app/favorites';
}

export function favoritePath(id: string): string {
  return `/app/favorites/${id}`;
}

export function agentsPath(): string {
  return '/app/agents';
}

export function projectsPath(): string {
  return '/app/projects';
}

export function projectPath(id: string): string {
  return `/app/projects/${id}`;
}

export function newProjectPath(): string {
  return '/app/projects/new';
}

export function editProjectPath(id: string): string {
  return `/app/projects/${id}/edit`;
}

export function projectArchivePath(id: string): string {
  return `/app/projects/${id}/archive`;
}

export function projectStatusPath(id: string): string {
  return `/app/projects/${id}/status`;
}

export function settingsPath(): string {
  return '/app/settings';
}

export function notificationPreferencePath(): string {
  return '/app/settings/notification_preference';
}

export function profilePath(): string {
  return '/app/settings/profile';
}

export function settingsPasswordPath(): string {
  return '/app/settings/password';
}

export function settingsSessionsPath(): string {
  return '/app/settings/sessions';
}

export function settingsSessionPath(id: string): string {
  return `/app/settings/sessions/${id}`;
}

export function settingsSessionsOthersPath(): string {
  return '/app/settings/sessions/others';
}

export function membersPath(): string {
  return '/app/settings/members';
}

export function settingsMemberPath(id: string): string {
  return `/app/settings/members/${id}`;
}

export function teamsPath(): string {
  return '/app/teams';
}

export function teamPath(id: string): string {
  return `/app/teams/${id}`;
}

export function cyclesPath(): string {
  return '/app/cycles';
}

export function viewsPath(): string {
  return '/app/views';
}

export function viewPath(id: string): string {
  return `/app/views/${id}`;
}

export function issueRelationsPath(issueId: string): string {
  return `/app/issues/${issueId}/relations`;
}

export function issueRelationPath(issueId: string, id: string): string {
  return `/app/issues/${issueId}/relations/${id}`;
}

export function documentPath(id: string): string {
  return `/app/documents/${id}`;
}

export function initiativesPath(): string {
  return '/app/initiatives';
}

export function reviewsPath(): string {
  return '/app/reviews';
}

export function documentsPath(): string {
  return '/app/documents';
}

export function companyContextPath(): string {
  return '/app/company_context';
}

export function companiesPath(): string {
  return '/app/companies';
}

export function companyPath(id: string): string {
  return `/app/companies/${id}`;
}

export function newCompanyPath(): string {
  return '/app/companies/new';
}

export function editCompanyPath(id: string): string {
  return `/app/companies/${id}/edit`;
}

export function invoicesPath(): string {
  return '/app/invoices';
}

export function newInvoicePath(): string {
  return '/app/invoices/new';
}

export function invoicePath(id: string): string {
  return `/app/invoices/${id}`;
}

export function invoiceDeliveryPath(id: string): string {
  return `/app/invoices/${id}/delivery`;
}

export function invoiceVoidancePath(id: string): string {
  return `/app/invoices/${id}/voidance`;
}

export function workspaceRootPath(): string {
  return '/app';
}

export function capturesPath(): string {
  return '/app/captures';
}

export function captureAttachmentPath(id: string): string {
  return `/app/captures/${id}/attachment`;
}

export function captureDismissalPath(id: string): string {
  return `/app/captures/${id}/dismissal`;
}

export function pullRequestItemAttachmentPath(id: string): string {
  return `/app/pull_request_items/${id}/attachment`;
}

export function pullRequestItemDismissalPath(id: string): string {
  return `/app/pull_request_items/${id}/dismissal`;
}

export function homePath(): string {
  return '/app/home';
}

export function openIssuePath(issue: { id: string; identifier?: string }): string {
  if (issue.identifier) {
    return issueIdentifierPath(issue.identifier);
  }

  return issuePath(issue.id);
}
